import React from 'react'
import {Grid} from '@material-ui/core'
import DeltagareItem from './DeltagareItem'
import _ from 'lodash'

const  DummyData = [
  {FirstName: 'jon', LastName: 'doe', value: 1000},
  {FirstName: 'jon', LastName: 'doe', value: 865},
  {FirstName: 'jon', LastName: 'doe', value: 678},
  {FirstName: 'jon', LastName: 'doe', value: 344},
  {FirstName: 'jon', LastName: 'doe', value: 233},
  {FirstName: 'jon', LastName: 'doe', value: 123},
]

export default function LeaderBoard(props) {
  return (
    <Grid container spacing={1}>
      {
        !_.isEmpty(props.Competition.compDataArr) && 
        props.Competition.compDataArr.map((d,i) => <DeltagareItem key={i} _index={i} deltagare={d} Competition={props.Competition}/>)
      }
    </Grid>
  )
}
